import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AuthService } from '@klickdata/core/auth';
import { File } from '@klickdata/core/file';
import { Media } from '@klickdata/core/media/src/media.model';
import { Filter } from '@klickdata/core/table';
import { User } from '@klickdata/core/user';
import { Observable, first, tap } from 'rxjs';

@Component({
    selector: 'app-menu-side-media-files',
    templateUrl: './menu-side-media-files.component.html',
    styleUrls: ['./menu-side-media-files.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideMediaFilesComponent implements OnInit {
    @Output() onExpanding: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onSelectFile: EventEmitter<File> = new EventEmitter<File>();
    public columns = ['thumbnil', 'filename', 'min_tools'];
    @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
    public privateTableFilterItems: Filter<string | number>[];
    public academyTableFilterItems: Filter<string | number>[];
    public libraryTableFilterItems: Filter<string | number>[] = [{ property: 'public', items: ['true'] }];
    public authUser: Observable<User>;
    constructor(protected auth: AuthService) {}

    ngOnInit(): void {
        this.authUser = this.auth.getUser().pipe(
            first(),
            tap((user) => {
                this.privateTableFilterItems = [{ property: 'author', items: [user.id] }];
                this.academyTableFilterItems = [{ property: 'customer', items: [user.customer_id] }];
            })
        );
    }
}
